import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, InfoOutlineIcon, Preloader, RawButton, Text, useResponsive } from '@common-fe/common-fe';

import useGetBeneficiariesQuery from '@/modules/user/components/ManageProfile/components/Beneficiaries/useGetBeneficiaries.query';
import { ManageProfileTabs } from '@/modules/user/components/ManageProfile/manageProfile.types';
import useRedirectToManageProfileTab from '@/modules/user/components/ManageProfile/useRedirectToManageProfileTab';

import { IconWrapper } from './AccountDetails.styles';

const BeneficiaryInfo = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const { isLoading, formattedData } = useGetBeneficiariesQuery();
  const { handleOpenManageProfileTab } = useRedirectToManageProfileTab();

  if (!isLoading && formattedData?.length) return null;

  return (
    <Box
      data-testId="BeneficiaryInfo"
      direction={isMobile ? 'column' : 'row'}
      background="canvas"
      round="container1Round"
      border={{ size: 'small', color: 'border2' }}
      justify="between"
      align={isMobile ? 'start' : 'center'}
      pad={{ horizontal: 'spacing16', vertical: 'spacing12' }}
      margin={{ top: 'spacing8' }}
    >
      {isLoading ? (
        <Preloader />
      ) : (
        <>
          <Box direction="row">
            <IconWrapper direction="row" align="center" justify="center">
              <InfoOutlineIcon color="iconPrimary" />
            </IconWrapper>
            <Text margin={{ left: 'spacing6' }} size="large" color="textBody" style={{ lineHeight: '24px' }}>
              {t("Don't forget to setup beneficiaries")}
            </Text>
          </Box>
          <Box pad={isMobile ? { horizontal: 'spacing16', top: 'spacing4' } : undefined}>
            <RawButton onClick={() => handleOpenManageProfileTab(ManageProfileTabs.BENEFICIARIES)}>
              <Box pad={{ horizontal: 'spacing16', vertical: 'spacing6' }}>
                <Text size="medium" color="textAccent" weight={400}>
                  {t('Add Beneficiaries')}
                </Text>
              </Box>
            </RawButton>
          </Box>
        </>
      )}
    </Box>
  );
};

export default BeneficiaryInfo;
